import { CUSTOM_ROUTINE_FEATURE, EMPTY_STRING } from 'constants/general';
import { t } from 'services/i18n.service';
import { useContext, useMemo } from 'react';
import { useAppDispatch } from 'store/hooks';
import { updateCustomRoutine } from 'store/reducer/setting/slice';
import DaysOfWeekMultiSelect from 'components/common/DaysOfWeekMultiSelect';
import { DaysOfWeek } from 'enums';
import { CustomRoutineContext } from '..';
import { MULTI_SELECT } from 'constants/multiSelect';

const RoutineDaysOfWeek = () => {
  const dispatch = useAppDispatch();
  const customRoutine = useContext(CustomRoutineContext);
  const daysOfWeek = useMemo(
    () => (customRoutine?.days_of_week ?? []) as DaysOfWeek[],
    [customRoutine]
  );

  return (
    <div className='flex flex-col ~gap-1/2'>
      <DaysOfWeekMultiSelect
        value={daysOfWeek}
        onChange={(days) => {
          if (!customRoutine) return;
          dispatch(
            updateCustomRoutine({
              feature: CUSTOM_ROUTINE_FEATURE.DAYS,
              position: customRoutine.position,
              value: days
            })
          );
        }}
        label={t('settings_page.repeat_on')}
        tooltip={t('settings_page.select_the_days_this_routine_should_run')}
        size='sm'
        data-testid='routine-days-of-week'
        btnClassName={
          !daysOfWeek.length ? 'border-2 !border-red-500' : EMPTY_STRING
        }
        visibleSelectedCount={
          MULTI_SELECT.CUSTOM_ROUTINE_DAYS_OF_WEEK_VISIBLE_SELECTED_COUNT
        }
      />
    </div>
  );
};

export default RoutineDaysOfWeek;
